import React from "react";
import { motion } from "framer-motion";

export default function Hero({ onOpenChat }) {
  return (
    <section
      id="hero"
      className="relative pt-32 pb-20 overflow-hidden bg-slate-50"
    >
      {/* Декоративный анимированный фон */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full opacity-30 pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-400 rounded-full blur-[120px] animate-pulse"></div>
        <div className="absolute bottom-[10%] right-[-10%] w-[30%] h-[30%] bg-indigo-400 rounded-full blur-[100px]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center space-y-8"
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-blue-100 text-blue-700 text-xs font-black uppercase tracking-widest border border-blue-200">
            Аккредитация Минцифры РФ
          </span>

          <h1 className="text-5xl md:text-7xl font-black text-slate-900 leading-tight tracking-tighter mb-8">
            Комплексные ИТ-решения <br />
            <span className="text-blue-600 italic">для всех отраслей</span>
          </h1>

          <p className="max-w-2xl mx-auto text-lg text-slate-500 font-medium leading-relaxed">
            Проектирование систем, информационная безопасность и техническая
            поддержка объектов информационной инфраструктуры.
          </p>

          <div className="flex justify-center gap-4 pt-4">
            <button
              onClick={onOpenChat}
              className="bg-blue-600 text-white px-10 py-5 rounded-2xl font-bold shadow-xl shadow-blue-200 hover:scale-105 transition-all"
            >
              Обсудить проект
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
